import { render, staticRenderFns } from "./Inscriptions.vue?vue&type=template&id=5009d495&scoped=true&"
import script from "./Inscriptions.vue?vue&type=script&lang=js&"
export * from "./Inscriptions.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions.vue?vue&type=style&index=0&id=5009d495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009d495",
  null
  
)

export default component.exports